import i18n from 'i18next';
import { initReactI18next, useTranslation as useTranslationHook } from 'react-i18next';

import { isProd } from '@app/helpers/environment';

import en from './locales/en.json';
import es from './locales/es.json';

i18n.use(initReactI18next).init({
  fallbackLng: 'en',
  // don't debug in production or when testing, only in development and staging
  debug: !isProd(window.location.hostname) && process.env.NODE_ENV !== 'test',
  interpolation: {
    escapeValue: false, // not needed for React as it escapes by default
  },
  returnObject: true, // allows objects as valid translation result
  parseMissingKeyHandler: () => undefined, // this makes it safe to do dynamic lookup, so it won't output the 'missing translation' string
  supportedLngs: ['en', 'en-US', 'es', 'es-ES'],
  resources: {
    en: {
      translation: en,
    },
    es: {
      translation: es,
    },
  },
});

export const useTranslation = useTranslationHook;

export const t = (key, options) => i18n.t(key, options);

export const changeLanguage = lng => i18n.changeLanguage(lng);

export default {
  useTranslation,
  t,
  changeLanguage,
};
